jQuery(function($) {
  if ( $('select[name="field_user_type"]').length > 0 )
  {
    var changeFieldUserType = function(t)
    {
      if ( !$('.is_adherent').hasClass('hide') )
      {
        if ( t.val() == 'individual' )
        {
          $('.only-company').addClass('hide')

          $('.only-company .label').removeClass('js-form-required form-required')
          $('.only-company :input').removeClass('required').removeAttr('required').removeAttr('aria-required')
        }
        else
        {
          $('.only-company').removeClass('hide')

          $('.only-company .label').addClass('js-form-required form-required')
          $('.only-company :input').addClass('required').prop('required', 'required').attr('aria-required', 'true')
        }
      }
      else
      {
        $('.only-company .label').removeClass('js-form-required form-required')
        $('.only-company :input').removeClass('required').removeAttr('required').removeAttr('aria-required')
      }
    }

    $('select[name="field_user_type"]').on('change', function ()
    {
      changeFieldUserType($(this))
    })

    changeFieldUserType($('select[name="field_user_type"]'))
  }

  var selectorDataUser = document.querySelector('script[type="application/json"][data-drupal-selector="drupal-user-data-json"]')
  if ( selectorDataUser )
  {
    var settingsDataUser = JSON.parse(selectorDataUser.textContent)
    if ( settingsDataUser.is_adherer == true )
    {
      $('.is_adherent').removeClass('hide')
    }
  }

  var drupal_current_language = 'fr';
  if ( drupalSettings.path.currentQuery != undefined )
  {
    drupal_current_language = drupalSettings.path.currentQuery.language;
  }
  else if ( drupalSettings.path.currentLanguage )
  {
    drupal_current_language = drupalSettings.path.currentLanguage;
  }

  if ( drupal_current_language == 'fr' )
  {
    $('#edit-pass .js-form-item-pass-pass1.password-parent label').html('Nouveau mot de passe');
    $('#edit-pass .js-form-item-pass-pass2.confirm-parent label').html('Confirmer le nouveau mot de passe');
  }
  else
  {
    $('#edit-pass .js-form-item-pass-pass1.password-parent label').html('New Password');
    $('#edit-pass .js-form-item-pass-pass2.confirm-parent label').html('Confirm the new password');
  }

  var ufFields = [
    '#edit-field-user-adresse-main-0-inline-entity-form-title-wrapper',
    '#edit-field-user-adresse-main-0-inline-entity-form-field-adr-adresse-intitule-wrapper',
    '#edit-field-user-adresse-main-0-inline-entity-form-field-adr-type-dadresse-wrapper',
    '.civility__wrapper',
    '#edit-field-user-adresse-main-0-inline-entity-form-field-adr-tiers-adresse-lastnam-wrapper',
    '#edit-field-user-adresse-main-0-inline-entity-form-field-adr-tiers-adresse-name-wrapper',
    '#edit-field-user-adresse-main-0-inline-entity-form-field-adr-tiers-adresse-ligne1-wrapper',
    '#edit-field-user-adresse-main-0-inline-entity-form-field-adr-tiers-adresse-ligne2-wrapper',
    '#edit-field-user-adresse-main-0-inline-entity-form-field-adr-tiers-adresse-cp-wrapper',
    '#edit-field-user-adresse-main-0-inline-entity-form-field-adr-tiers-adresse-city-wrapper',
    '.row[data-drupal-selector="edit-field-user-adresse-main-widget-0-inline-entity-form-group-row"]',
    '[data-drupal-selector="edit-field-user-adresse-main-widget-0-inline-entity-form-group-col-sm-64"]',
  ];
  ufFields.forEach(function(element) {
    $('.is_adherent #edit-field-user-adresse-main-wrapper ' + element).addClass('hide');
  });
});


// WEBPACK FOOTER //
// ./js/user-form.js